import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=651decb2&scoped=true"
import script from "./CompanyInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompanyInfo.vue?vue&type=style&index=0&id=651decb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651decb2",
  null
  
)

export default component.exports